const actions = {

  DESIGNATIONS_READ_BEGIN: 'DESIGNATIONS_READ_BEGIN',
  DESIGNATIONS_READ_SUCCESS: 'DESIGNATIONS_READ_SUCCESS',
  DESIGNATIONS_READ_ERR: 'DESIGNATIONS_READ_ERR',
  
  DESIGNATIONS_ADD_BEGIN: 'DESIGNATIONS_ADD_BEGIN',
  DESIGNATIONS_ADD_SUCCESS: 'DESIGNATIONS_ADD_SUCCESS',
  DESIGNATIONS_ADD_ERR: 'DESIGNATIONS_ADD_ERR',

  DESIGNATIONS_UPDATE_BEGIN: 'DESIGNATIONS_UPDATE_BEGIN',
  DESIGNATIONS_UPDATE_SUCCESS: 'DESIGNATIONS_UPDATE_SUCCESS',
  DESIGNATIONS_UPDATE_ERR: 'DESIGNATIONS_UPDATE_ERR',

  designationsReadBegin: () => {
    return {
      type: actions.DESIGNATIONS_READ_BEGIN,
    };
  },

  designationsReadSuccess: (data) => {
    return {
      type: actions.DESIGNATIONS_READ_SUCCESS,
      data,
    };
  },

  designationsReadErr: (err) => {
    return {
      type: actions.DESIGNATIONS_READ_ERR,
      err,
    };
  },
  
  designationsAddBegin: () => {
    return {
      type: actions.DESIGNATIONS_ADD_BEGIN,
    };
  },

  designationsAddSuccess: (data) => {
    return {
      type: actions.DESIGNATIONS_ADD_SUCCESS,
      data,
    };
  },

  designationsAddErr: (err) => {
    return {
      type: actions.DESIGNATIONS_ADD_ERR,
      err,
    };
  },

  designationsUpdateBegin: () => {
    return {
      type: actions.DESIGNATIONS_UPDATE_BEGIN,
    };
  },

  designationsUpdateSuccess: (data) => {
    return {
      type: actions.DESIGNATIONS_UPDATE_SUCCESS,
      data,
    };
  },

  designationsUpdateErr: (err) => {
    return {
      type: actions.DESIGNATIONS_UPDATE_ERR,
      err,
    };
  },
      
};

export default actions;
